import * as empStatusActionCreator from "./empStatusActionCreator";

export function defaultEmpStatusState() {
  return {
    loading: false,
    response: null,
    error: null,
  };
}

export const EmpStatusReducer = (state, action) => {
  if (
    !state ||
    action.type ===
      empStatusActionCreator.EMP_STATUS_ACTION.RESET_EMP_STATUS_STATE
  ) {
    return { ...state, ...defaultEmpStatusState() };
  }

  if (
    action.type === empStatusActionCreator.EMP_STATUS_ACTION.EMP_STATUS_REQUEST
  ) {
    return { ...state, loading: true };
  }

  if (
    action.type === empStatusActionCreator.EMP_STATUS_ACTION.EMP_STATUS_RESPONSE
  ) {
    return { ...state, response: action.data, loading: false };
  }

  if (
    action.type === empStatusActionCreator.EMP_STATUS_ACTION.EMP_STATUS_ERROR
  ) {
    return { ...state, error: action.data, loading: false };
  }

  return state;
};

export function defaultGetEmpStatusState() {
  return {
    loading: false,
    response: null,
    error: null,
  };
}

export const GetEmpStatusReducer = (state, action) => {
  if (
    !state ||
    action.type ===
      empStatusActionCreator.EMP_STATUS_ACTION.RESET_GET_EMP_STATUS
  ) {
    return { ...state, ...defaultGetEmpStatusState() };
  }

  if (
    action.type === empStatusActionCreator.EMP_STATUS_ACTION.GET_EMP_STATUS_REQUEST
  ) {
    const isSilent = action.silent || false;
    return isSilent ? state : { ...state, loading: true };
  }

  if (
    action.type ===
    empStatusActionCreator.EMP_STATUS_ACTION.GET_EMP_STATUS_RESPONSE
  ) {
    return { ...state, response: action.data, loading: false };
  }

  if (
    action.type ===
    empStatusActionCreator.EMP_STATUS_ACTION.GET_EMP_STATUS_ERROR
  ) {
    return { ...state, error: action.data, loading: false };
  }

  return state;
};


export function defaultGetDocTypesState() {
  return {
    loading: false,
    response: null,
    error: null,
  };
}

export const GetDocTypesReducer = (state, action) => {
  if (
    !state ||
    action.type ===
      empStatusActionCreator.EMP_STATUS_ACTION.RESET_DOC_TYPES_STATE
  ) {
    return { ...state, ...defaultGetDocTypesState() };
  }

  if (
    action.type ===
    empStatusActionCreator.EMP_STATUS_ACTION.GET_DOCTYPE_REQUEST
  ) {
    return { ...state, loading: true };
  }

  if (
    action.type ===
    empStatusActionCreator.EMP_STATUS_ACTION.GET_DOCTYPE_RESPONSE
  ) {
    return { ...state, response: action.data, loading: false };
  }

  if (
    action.type ===
    empStatusActionCreator.EMP_STATUS_ACTION.GET_DOCTYPE_ERROR
  ) {
    return { ...state, error: action.data, loading: false };
  }

  return state;
};

export function defaultDocumentUploadState() {
  return {
    loading: false,
    response: null,
    error: null,
  };
}

export const DocumentUploadReducer = (state, action) => {
  if (
    !state ||
    action.type ===
      empStatusActionCreator.EMP_STATUS_ACTION.RESET_DOCUMENT_UPLOAD_STATE
  ) {
    return { ...state, ...defaultDocumentUploadState() };
  }

  if (
    action.type === empStatusActionCreator.EMP_STATUS_ACTION.REQUEST_DOCUMENT_UPLOAD
  ) {
    return { ...state, loading: true };
  }

  if (
    action.type === empStatusActionCreator.EMP_STATUS_ACTION.RESPONSE_DOCUMENT_UPLOAD
  ) {
    return { ...state, response: action.data, loading: false };
  }

  if (
    action.type === empStatusActionCreator.EMP_STATUS_ACTION.ERROR_DOCUMENT_UPLOAD
  ) {
    return { ...state, error: action.data, loading: false };
  }
  return state;
};
